module.exports = __webpack_public_path__ + "img/Max.6398d655.png";